import React from 'react';
import {Camera} from '../types';
import Checkbox from './Checkbox';
import {useDispatch} from 'react-redux';
import {toggleCamera} from '../actions';

type Props = {
  camera: Camera,
  isSelected: boolean
}

const CameraComponent = ( props: Props ) => {
  const dispatch = useDispatch();
  return (<div
    className='CameraComponent no-selection'
    onClick={ () => { dispatch(toggleCamera({
      toggleTo: !props.isSelected,
      camera: props.camera
    })); } }
    >
    <Checkbox
      checked={props.isSelected}
      onToggle={ ( toggleTo: boolean ) => {
        dispatch(toggleCamera({
          toggleTo,
          camera: props.camera
        }));
      }}
    />
    <span className='camera-title ellipsis'>{props.camera.title}</span>
  </div>);
};

export default CameraComponent;